import { render } from "./xuexiTable.vue?vue&type=template&id=fdb99b9a"
import script from "./xuexiTable.vue?vue&type=script&lang=js"
export * from "./xuexiTable.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ryancompany/works/bao/xinyuanyiyuan/pet-mobile-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__